/**
 * Global crash/error reporter for the app (web + Android/iOS).
 * Sends uncaught errors and unhandled promise rejections to the backend for logging.
 */

// const getApiBase = () =>
//   process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || 'https://restroai.in/api';

const getApiBase = () =>
  process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || 'https://restro-backend-vercel.vercel.app/api';

const getPlatform = () => {
  if (typeof window === 'undefined') return 'unknown';
  if (window.Capacitor?.getPlatform) {
    try {
      return window.Capacitor.getPlatform(); // 'android' | 'ios' | 'web'
    } catch (_) {}
  }
  return window.navigator?.userAgent?.toLowerCase().includes('android') ? 'android' : 'web';
};

const getAppVersion = () => {
  try {
    const Cap = window.Capacitor;
    if (Cap?.getApp && typeof Cap.getApp === 'function') {
      return Cap.getApp().then((app) => (app && app.getInfo ? app.getInfo() : null)).then((info) => (info && info.version) ? info.version : null).catch(() => null);
    }
  } catch (_) {}
  return Promise.resolve(null);
};

const getUserId = () => {
  try {
    const userData = localStorage.getItem('userData');
    if (userData) {
      const u = JSON.parse(userData);
      return u?.id || u?.userId || null;
    }
  } catch (_) {}
  return null;
};

function sendCrashReport(payload) {
  const url = `${getApiBase()}/logs/crash`;
  const body = JSON.stringify({
    ...payload,
    url: typeof window !== 'undefined' ? window.location?.href : '',
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
    platform: getPlatform(),
    userId: getUserId(),
    timestamp: new Date().toISOString(),
  });

  if (navigator.sendBeacon) {
    try {
      navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
      return;
    } catch (_) {}
  }
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
  }).catch(() => {});
}

function initCrashReporter() {
  getAppVersion().then((appVersion) => {
    const defaultMeta = { appVersion: appVersion || undefined };

    window.onerror = (message, source, line, column, error) => {
      const stack = error?.stack || '';
      console.error('[CrashReporter]', message, stack);
      sendCrashReport({
        message: typeof message === 'string' ? message : String(message),
        stack,
        source: source || '',
        line: line ?? null,
        column: column ?? null,
        errorType: 'window.onerror',
        ...defaultMeta,
      });
      return false;
    };

    window.onunhandledrejection = (event) => {
      const reason = event?.reason;
      const message = reason?.message ?? String(reason);
      const stack = reason?.stack || '';
      console.error('[CrashReporter] unhandledrejection', message, stack);
      sendCrashReport({
        message: message || 'Unhandled promise rejection',
        stack,
        errorType: 'unhandledrejection',
        ...defaultMeta,
      });
    };
  });
}

export { initCrashReporter, sendCrashReport };
